import { useEffect, useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { pushEnabled, identifyPushUser, enablePush, currentPermission } from "@/lib/onesignal";
import { toast } from "sonner";

export const PushToggle = ({ className = "" }) => {
  const { user } = useAuth();
  const [granted, setGranted] = useState(false);

  useEffect(() => {
    if (!user || !user.id || !user.role) return;
    identifyPushUser(user.role, user.id);
    currentPermission().then(setGranted);
  }, [user]);

  if (!pushEnabled() || !user) return null;

  const enable = async () => {
    try {
      const perm = await enablePush(user.role, user.id);
      if (perm) { setGranted(true); toast.success("Notifications activées"); }
      else toast.error("Autorisation refusée — activez les notifications dans les réglages du navigateur");
    } catch (e) {
      toast.error("Notifications indisponibles sur ce navigateur");
    }
  };

  return (
    <button data-testid="push-enable-button" onClick={enable}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl text-xs border border-amber-500/30 text-amber-200 bg-[#161926] hover:bg-amber-500/10 transition-all ${className}`}>
      {granted ? <BellRing className="w-4 h-4" /> : <Bell className="w-4 h-4" />}
      {granted ? "Notifications activées (toucher pour réassocier)" : "Activer les notifications"}
    </button>
  );
};
